/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogLastStep } from './DriverRegistrationLogLastStep';
import type { RegistrationUniqueIdentifiers } from './RegistrationUniqueIdentifiers';
import type { GetSignupProcessFeaturesResponse } from './GetSignupProcessFeaturesResponse';
import type { FlowLanguage } from './FlowLanguage';
import type { DriverRegistrationLogStatus } from './DriverRegistrationLogStatus';
import type { CommonTranslations } from './CommonTranslations';
import type { Step } from './Step';
import type { FinalScreen } from './FinalScreen';

export interface GetFieldsResponse {
    steps: Array<Step>;
    final_screen?: FinalScreen;
    current_step: DriverRegistrationLogLastStep;
    common_translations: CommonTranslations;
    language: string;
    languages: Array<FlowLanguage>;
    driver_registration_log_status: DriverRegistrationLogStatus;
    flow_id?: number;
    /** Custom type: \"city_id\" */
    city_id?: number;
    city?: string;
    /** 2 char country code, for example: \'us\', \'ee\', \'gb\' */
    country?: string;
    features: GetSignupProcessFeaturesResponse;
    registration_identifiers?: RegistrationUniqueIdentifiers;
}
